import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getAdminProfile = async () => {
  const response = await api.get('/admin/profile');
  return response.data;
};

export const updateAdminProfile = async (profileData) => {
  const { author_name, bio } = profileData;
  const response = await api.put('/admin/profile', {
    author_name,
    bio
  });
  return response.data;
};

export const updateProfileImage = async (imageFile) => {
  const formData = new FormData();
  formData.append('profileImage', imageFile);
  const response = await api.put('/admin/profile/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateBannerImage = async (imageFile) => {
  const formData = new FormData();
  formData.append('bannerImage', imageFile);
  const response = await api.put('/admin/profile/banner', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};